import { useState } from "react";
import {
  RequestUpdateBaseRequest,
  BasesUpdateBasePostRequest,
  BasesApi,
} from "../../services/OpenAPI";
import { createConfiguration } from "./common";

export const useApiUpdateBase = () => {
  const [result, setResult] = useState<boolean>(false);
  const [error, setError] = useState<string | null>(null);
  const [isLoading, setIsLoading] = useState<boolean>(false);

  const updateBase = async (req: RequestUpdateBaseRequest) => {
    setIsLoading(true);
    setError(null);

    try {
      setIsLoading(true);
      const config = createConfiguration();
      const request: BasesUpdateBasePostRequest = {
        req,
      };

      const api = new BasesApi(config);
      const response = await api.basesUpdateBasePost(request);
      setResult(response);
      return response;
    } catch (err) {
      setError("更新に失敗しました");
      console.error(err);
      return null;
    } finally {
      setIsLoading(false);
    }
  };

  return { updateBase, error, isLoading };
};
